import { render, staticRenderFns } from "./ThemeSettingsDirectTopBmw.vue?vue&type=template&id=2b520c60&scoped=true"
import script from "./ThemeSettingsDirectTopBmw.vue?vue&type=script&lang=js"
export * from "./ThemeSettingsDirectTopBmw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b520c60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b520c60')) {
      api.createRecord('2b520c60', component.options)
    } else {
      api.reload('2b520c60', component.options)
    }
    module.hot.accept("./ThemeSettingsDirectTopBmw.vue?vue&type=template&id=2b520c60&scoped=true", function () {
      api.rerender('2b520c60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/projects/themes/ThemeSettingsDirectTopBmw.vue"
export default component.exports